<template>
  <div style="padding:16px;">
    <el-card>
      <div slot="header">{{ $t('salesAmountPage.cardTitle') }}</div>
      <el-form inline>
        <el-form-item :label="$t('salesAmountPage.month')"><el-input v-model="form.periodMonth" placeholder="yyyy-MM" style="width:140px;" /></el-form-item>
        <el-form-item :label="$t('salesAmountPage.amount')"><el-input v-model="form.salesAmount" /></el-form-item>
        <el-form-item :label="$t('salesAmountPage.salesperson')" v-if="!isSalesOnly">
          <el-select v-model="form.salespersonUserId" clearable filterable :placeholder="$t('common.pleaseSelect')" style="width:200px;">
            <el-option v-for="s in salesOptions" :key="s.value" :label="s.label" :value="s.value" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="save">{{ $t('common.save') }}</el-button></el-form-item>
      </el-form>
      <el-table :data="list" border size="small" style="margin-top:12px;">
        <el-table-column prop="periodMonth" :label="$t('salesAmountPage.month')" width="100" />
        <el-table-column :label="$t('salesAmountPage.salesperson')" min-width="120">
          <template slot-scope="scope">{{ salespersonLabel(scope.row.salespersonUserId) }}</template>
        </el-table-column>
        <el-table-column prop="salesAmount" :label="$t('salesAmountPage.amount')" />
      </el-table>
      <el-pagination style="margin-top:12px;text-align:right;" background layout="total, prev, pager, next"
        :total="total" :page-size="pageSize" :current-page="pageNo" @current-change="p => { pageNo = p; load() }" />
    </el-card>
  </div>
</template>

<script>
import { getSalesAmountPage, saveSalesAmount } from '@/api/salesAmount'
import { getSalesUserList } from '@/api/user'

export default {
  name: 'SalesAmount',
  data() {
    return {
      isSalesOnly: false,
      form: { periodMonth: '', salesAmount: '', salespersonUserId: '' },
      salesOptions: [],
      list: [],
      total: 0,
      pageNo: 1,
      pageSize: 10
    }
  },
  async created() {
    const roles = (this.$store.state.userInfo && this.$store.state.userInfo.roleCodes) || []
    this.isSalesOnly = roles.includes('SALES') && !roles.includes('OFFICE') && !roles.includes('ADMIN')
    if (!this.isSalesOnly) {
      await this.loadSalesOptions()
    }
    this.load()
  },
  methods: {
    async loadSalesOptions() {
      try {
        const resp = await getSalesUserList()
        const rows = (resp && resp.list) || []
        this.salesOptions = rows.map(r => ({
          value: r.id,
          label: (r.realName || r.username || '').trim() || this.$t('common.unnamed')
        }))
      } catch (e) {
        this.salesOptions = []
      }
    },

    salespersonLabel(uid) {
      if (uid === null || uid === undefined || uid === '') return '—'
      const hit = this.salesOptions.find(s => Number(s.value) === Number(uid))
      if (hit) return hit.label
      const selfId = this.$store.state.userInfo && this.$store.state.userInfo.userId
      if (this.isSalesOnly && selfId != null && Number(selfId) === Number(uid)) {
        const rn = this.$store.state.userInfo.realName
        const un = this.$store.state.userInfo.username
        return (rn || un || '').trim() || '—'
      }
      return '—'
    },

    async load() {
      const r = await getSalesAmountPage({ pageNo: this.pageNo, pageSize: this.pageSize })
      const d = r.data || r
      this.list = d.records || []
      this.total = d.total || 0
    },
    async save() {
      const payload = {
        periodMonth: this.form.periodMonth,
        salesAmount: Number(this.form.salesAmount),
        salespersonUserId: this.isSalesOnly
          ? this.$store.state.userInfo.userId
          : this.form.salespersonUserId
      }
      await saveSalesAmount(payload)
      this.$message.success(this.$t('salesAmountPage.saved'))
      this.load()
    }
  }
}
</script>
